import { RootState } from "@/store/store";
import { ResourceType } from "@/services/cloudchipr.api";
import { gridByIdSelector } from "@/store/resources-grid/selectors/grid/gridByIdSelector";

export const resourceGridListingPriceFrequencySelector = (
  state: RootState,
  resourceType: ResourceType,
  masterGridId?: string,
) => {
  if (!masterGridId) {
    return;
  }

  const grid = gridByIdSelector(state, masterGridId);

  return grid?.listingPriceFrequencies?.[resourceType];
};
